import { createConfirmation } from "react-confirm";
import MessageModal from "./MessageModal";

export const showMessageModal = createConfirmation(MessageModal);
